module.exports = __webpack_public_path__ + "img/logo-afrihost@3x.23c26fe7.png";